/* global mixpanel */

export function libraryTaxStart ({currOutlet}) {
  mixpanel.track('Library Tax Start', {
    'Current Selected Outlet': currOutlet
  })
}

export function libraryChangeOutlet ({currOutlet}) {
  mixpanel.track('Library Tax Change Outlet', {
    'Current Selected Outlet': currOutlet
  })
}

export function libraryCreateTax ({tax, isAllOutlet}) {
  const eventName = isAllOutlet ? 'Library Tax Create All Outlet' : 'Library Tax Create One Outlet'
  mixpanel.track(eventName, {
    'Name': tax.name,
    'Value': tax.amount
  })
}

export function libraryUpdateOneOutlet ({newName}) {
  mixpanel.track('Library Tax Update One Outlet', {
    'New Name': newName.name,
    'New Value': newName.amount
  })
}

export function libraryDeleteTax ({tax}) {
  mixpanel.track('Library Tax Delete', {
    'Name': tax.name,
    'Value': tax.amount
  })
}



// WEBPACK FOOTER //
// ./app/mixpanel/library/tax.js